import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card } from 'reactstrap';

import { PathsLayouts } from '../../../config/routes';
import { TranslationsKeys } from '../../../locales/translations';
import { StudyPlanListFilters } from './api';
import { SearchFiltersLoader } from './hooks/SearchFiltersLoader';
import SearchFilters, { Filters } from './parts/SearchFilters';
import StudyPlansList from './parts/StudyPlansList';

const StudyPlans = () => {
  const history = useHistory();
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_STUDY_PLANS,
  );
  const [filters, setFilters] = useState<Filters>({
    name: null,
    code: null,
    school: null,
    modality: null,
    campus: null,
  });

  const apiFilters = useMemo<StudyPlanListFilters>(() => {
    return {
      name: filters.name || undefined,
      code: filters.code || undefined,
      schoolId: filters.school?.value as number | undefined,
      modalityId: filters.modality?.value as number | undefined,
      campusId: filters.campus?.value as number | undefined,
    };
  }, [filters]);

  const handleFiltersChange = (filterValues: Filters) => {
    setFilters(filterValues);
  };

  const handleCreateCourse = () => {
    history.push(
      `${PathsLayouts.continuousEducation}/study-plans/create-course`,
    );
  };

  const handleCreateProgram = () => {
    history.push(
      `${PathsLayouts.continuousEducation}/study-plans/create-program-course`,
    );
  };

  return (
    <div className="mx-3">
      <Card className="p-4 mt-2">
        <h2 className="text-primary fs-20 fw-700 mb-4 text-uppercase">
          {t('title')}
        </h2>
        <SearchFiltersLoader fetchImmediately>
          <SearchFilters
            onFiltersChange={handleFiltersChange}
            createHandlers={{
              onCreateCourse: handleCreateCourse,
              onCreateProgram: handleCreateProgram,
            }}
          />
        </SearchFiltersLoader>

        <StudyPlansList filters={apiFilters} />
      </Card>
    </div>
  );
};

const CeStudyPlans = () => {
  return <StudyPlans />;
};

export default CeStudyPlans;
